import moment from 'moment'

export const formatStrDate = datetime => {
  const formatStr = 'DD/MM/YYYY HH:mm'
  return moment(datetime).format(formatStr)
}
